var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { PIGMENT_CDN_URL } from '../../config';
var logoHorizontalUrl = "".concat(PIGMENT_CDN_URL, "/images/logo-large-horizontal.svg");
var logoVerticalUrl = "".concat(PIGMENT_CDN_URL, "/images/logo-large-vertical.svg");
var logoInkyUrl = "".concat(PIGMENT_CDN_URL, "/images/logo-large-icon.svg");
/**
 * Pigment [Logo](https://pigment.customink.com/?path=/docs/components-logo)
 * @param {string} variant horizontal | vertical | inky
 */
var Logo = function (_a) {
  var onClick = _a.onClick,
    _b = _a.variant,
    variant = _b === void 0 ? 'horizontal' : _b,
    props = __rest(_a, ["onClick", "variant"]);
  var variantMap = {
    horizontal: logoHorizontalUrl,
    vertical: logoVerticalUrl,
    inky: logoInkyUrl
  };
  return /*#__PURE__*/React.createElement("img", __assign({
    src: variantMap[variant],
    onClick: onClick
  }, props));
};
export default Logo;